import { IUser } from "src/api-authorization/IUserModel";
import { EmployeeService } from "src/app/services/employee.service";

export class EmployeeSetting {
    SettingName: string;
    BranchId: number;
    EmployeeId: number;
    ValueType: number;
    ValueAsNumber: number;
    ValueAsString: string;
    ValueAsDateTime: Date;
    ValueAsBool: boolean;

    public static Create(n: EmployeeSetting) {
        var s = new EmployeeSetting();
        s.BranchId = n.BranchId;
        s.EmployeeId = n.EmployeeId;
        s.SettingName = n.SettingName;
        s.ValueAsBool = n.ValueAsBool;
        s.ValueAsDateTime = new Date(n.ValueAsDateTime);
        s.ValueAsNumber = n.ValueAsNumber;
        s.ValueAsString = n.ValueAsString;
        s.ValueType = n.ValueType;
        return s;
    }
}

export class Employee {
    public EmployeeId: number = -1;
    public Title: string = "";
    public FirstName: string = "";
    public LastName: string = "";
    public MobileTelephone: string = "";
    public EmailAddress: string = "";
    public IsAdmin: boolean = false;
    public PrivString: string = "";
    public UID: string = "";
    public Active: boolean = false;
    public BranchId: number = null;
    public CanEditPrices: boolean = false;

    public ChangePIN1: string = "";
    public ChangePIN2: string = "";
    public ChangePassword1: string = "";
    public ChangePassword2: string = "";
    public Settings: EmployeeSetting[] = [];

    // Fields used by SPA
    public Selected: boolean = false;
    public Pin: string = "";

    public static CreateFrom(e: Employee): Employee {
        if (!e)
            return null;
        var employee: Employee = new Employee();
        employee.Title=e.Title;
        employee.FirstName = e.FirstName;
        employee.LastName = e.LastName;
        employee.EmployeeId = e.EmployeeId;
        employee.MobileTelephone = e.MobileTelephone;        
        employee.EmailAddress = e.EmailAddress;
        employee.IsAdmin = e.IsAdmin;
        employee.Title = e.Title;
        employee.UID = e.UID;
        employee.PrivString = e.PrivString;
        employee.Active = e.Active;
        employee.BranchId = e.BranchId;
        employee.CanEditPrices = e.CanEditPrices;
        employee.ChangePIN1="";
        employee.ChangePIN2="";
        employee.ChangePassword1="";
        employee.ChangePassword2="";

        if (e.Settings)
            employee.Settings = e.Settings.map(i => EmployeeSetting.Create(i));
            
        return employee;
    }

    constructor() {
    }

    public Reset() {
        this.EmployeeId = -1;
        this.Title = "";
        this.FirstName = "";
        this.LastName = "";
        this.IsAdmin = false;
        this.UID = "";
        this.EmailAddress = "";
        this.MobileTelephone = "";
        this.ChangePIN1 = "";
        this.ChangePIN2 = "";
        this.ChangePassword1 = "";
        this.ChangePassword2 = "";
        this.PrivString = "";
        this.Active = false;
        this.BranchId = null;
        this.Settings = [];
        this.CanEditPrices = false;

        this.Pin = "";
        this.Selected = false;
    }

    public get FullName(): string {
        return this.FirstName + " " + this.LastName;
    }

    ReadSettingNumber(SettingName: string, defaultValue: number = -1, BranchId: number): number {
        var x: EmployeeSetting = this.Settings.find(i => i.SettingName == SettingName && i.BranchId == BranchId && i.ValueType == 6);
        if (x)
            return x.ValueAsNumber;
        else
            return defaultValue;
    }

    SaveSettingNumber(SettingName: string, Value: number, BranchId: number): void {
        var x: EmployeeSetting = this.Settings.find(i => i.SettingName == SettingName && i.BranchId == BranchId && i.ValueType == 6);
        if (x) {
            x.ValueAsNumber = Value;
        }
        else {
            x = new EmployeeSetting();
            x.BranchId = BranchId;
            x.EmployeeId = this.EmployeeId;
            x.ValueType = 6;
            x.SettingName = SettingName;
            x.ValueAsNumber = Value;
            this.Settings.push(x);
        }
    }
};